<template>
  <div class="common-card" :class="shadow ? 'is-' + shadow + '-shadow' : 'is-never-shadow'" :style="cardStyle">
    <div class="common-card__header" v-if="$slots.title || title || $slots.action">
        <div class="common-card__title" v-if="$slots.title || title">
            <slot name="title">{{ title }}</slot>
        </div>
        <div class="common-card__action" v-if="$slots.action">
            <slot name="action"></slot>
        </div>
    </div>
    <div class="common-card__body" :style="bodyStyle">
        <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
    name: 'CommonCard',
    props: {
        title: {},
        action: {},
        cardStyle: {
            type: Object,
            default: function() {
                return {
                    margin: '16px'
                }
            }
        },
        bodyStyle: {},
        shadow: {
            type: String
        }
    }
}
</script>
